import JassEnum from './enum';

/**
 * type playerscore
 */
export default class JassPlayerScore extends JassEnum {}
